import { NavLink } from 'react-router-dom'
import styled from '@emotion/styled'
import Badge from '@/components/generics/Badge'
import isPropValid from '@emotion/is-prop-valid'
import { ThemeProp } from '@/styles/theme'

export const submenuStyle = ({ theme }: ThemeProp) => `
  background: ${theme.ds.ColorBaseGreyLevel4};
  span {
    margin-left: 24px;
  }
`

export const Link = styled(NavLink, {
  shouldForwardProp: isPropValid,
})<{
  isSubmenu: boolean
  customCss?: string
}>`
  ${({ isSubmenu }) => (isSubmenu ? submenuStyle : '')}
  ${({ customCss }) => customCss ?? ''}
`

export const Tag = styled(Badge)`
  ${({ theme }) => `
    height: 16px;
    display: flex;
    align-items: center;
    background-color: ${theme.ds.ColorBaseYellowLevel6};
    font-weight: 700;
    font-size: 8px;
    line-height: normal;
  `}
`
